module.exports = __webpack_public_path__ + "static/media/racoon.8f5ec39b.png";